import {
  EditBlockColorPicker,
  EditBlockSelect,
  EditBlockTextInput,
  EditBlockNumericInput,
  EditBlockSliderInput,
} from '@components/EditBuildingBlocks/all'
import genericContentItemEditor from '@components/mixins/genericContentItemEditor'

export default {
  name: 'SocialEditorComponent',
  mixins: [genericContentItemEditor],
  components: {
    'edit-block-color-picker': EditBlockColorPicker,
    'edit-block-select': EditBlockSelect,
    'edit-block-text-input': EditBlockTextInput,
    'edit-block-numeric-input': EditBlockNumericInput,
    'edit-block-slider-input': EditBlockSliderInput,
  },
  data() {
    return {
      socialSelectedServices: JSON.parse(JSON.stringify(this.component.content.selectedServices)),
      socialServices: JSON.parse(JSON.stringify(this.component.content.services)),
    }
  },
  computed: {
    socialIconColor: {
      get() {
        return this.component.styling.color
      },
      set(value) {
        this.updateContentItem({
          id: this.component.id,
          path: ['styling'],
          attribute: ['color'],
          data: value,
        })
      },
    },
    textAlign: {
      get() {
        return this.component.styling.textAlign
      },
      set(value) {
        this.updateContentItem({
          id: this.component.id,
          path: ['styling'],
          attribute: ['textAlign'],
          data: value,
        })
      },
    },
    socialDirection: {
      get() {
        return this.component.styling.direction
      },
      set(value) {
        this.updateContentItem({
          id: this.component.id,
          path: ['styling'],
          attribute: ['direction'],
          data: value,
        })
      },
    },
  },
  watch: {
    socialSelectedServices: function(value) {
      this.updateContentItem({
        id: this.component.id,
        path: ['content'],
        attribute: ['selectedServices'],
        data: JSON.parse(JSON.stringify(value)),
      })
    },
    socialServices: {
      handler: function(value) {
        this.updateContentItem({
          id: this.component.id,
          path: ['content'],
          attribute: ['services'],
          data: JSON.parse(JSON.stringify(value)),
        })
      },
      deep: true,
    },
  },
  methods: {
    addSocial() {
      let addedNewSocial = false

      Object.keys(this.component.content.services).forEach((key) => {
        if (!this.socialSelectedServices.includes(key) && !addedNewSocial) {
          this.socialSelectedServices.push(key)
          addedNewSocial = true
        }
      })
    },
    removeSocial(index) {
      this.socialSelectedServices.splice(index, 1)
    },
  },
}
